import { useState } from "react";
import { useLocale } from "../../i18n/LocaleProvider";
import { SubmitRow } from "./SubmitRow";
import styles from "./questions.module.css";

interface Props {
  value: string | undefined;
  optional: boolean;
  onSubmit: (value: string | undefined) => void;
}

export function TextInput({ value, optional, onSubmit }: Props) {
  const { t } = useLocale();
  const [text, setText] = useState(value ?? "");
  return (
    <div className={styles.stack}>
      <textarea
        className={`${styles.field} ${styles.textarea}`}
        placeholder={t.questionnaire.notePlaceholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <SubmitRow onNext={() => onSubmit(text)} onSkip={optional && text.trim() === "" ? () => onSubmit(undefined) : undefined} />
    </div>
  );
}
